import { useState, useEffect } from "react";

export const useCallTimers = () => {
  const [currentTime, setCurrentTime] = useState(() => new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  const calculateTimer = (startTime?: string | Date): string => {
    if (!startTime) return "00:00:00";

    const start = new Date(startTime);
    const diffInSeconds = Math.floor((currentTime.getTime() - start.getTime()) / 1000);

    if (isNaN(diffInSeconds) || diffInSeconds < 0) return "00:00:00";

    const hours = Math.floor(diffInSeconds / 3600).toString().padStart(2, "0");
    const minutes = Math.floor((diffInSeconds % 3600) / 60).toString().padStart(2, "0");
    const seconds = (diffInSeconds % 60).toString().padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  return { calculateTimer };
};
